import script from "./reviewVoca.vue?vue&type=script&setup=true&lang=js"
export * from "./reviewVoca.vue?vue&type=script&setup=true&lang=js"

import "./reviewVoca.vue?vue&type=style&index=0&id=ada2ff52&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada2ff52"]])

export default __exports__